import { BaseFaqItemFragment } from '@flipster/features/src/contentful/faq/query.generated';
import { css } from '@flipster/styled-system/css';

import Designed from './sections/Designed';
import SpotHero from './sections/Hero/SpotHero';
import { Faq } from './sections/faq';

interface Props {
  faqs?: BaseFaqItemFragment[];
}

const SpotMainPage = ({ faqs }: Props) => {
  return (
    <main className={css({ pos: 'relative', overflowX: 'hidden', mb: { base: 56, tablet: 150 } })}>
      <SpotHero />
      <Designed />
      <Faq faqs={faqs} />
    </main>
  );
};

export default SpotMainPage;
